import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const FormatTextdirectionLToRIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"format_textdirection_l_to_r"} ref={ref}/>
});

FormatTextdirectionLToRIcon.displayName = "FormatTextdirectionLToRIcon";
